/**
 * component-accordion.js -- Accordion Section Web Component for Mirai Online (Phase 3)
 *
 * <accordion-section> custom element:
 *  - Toggles its own .accordion__trigger / .accordion__panel on click
 *  - Flips aria-expanded and the accordion__panel--open class (CSS animates max-height)
 *  - Preserves the server-rendered initial open state (Fabric stays open on load)
 *  - Multiple accordions may be open simultaneously (no single-open constraint, per D-13)
 *  - Theme editor compatible via shopify:section:load reinit
 *  - Light DOM only (no Shadow DOM)
 */

class AccordionSection extends HTMLElement {
  constructor() {
    super();
    this._boundToggle = this._toggle.bind(this);
  }

  connectedCallback() {
    this._init();
    this.addEventListener('shopify:section:load', () => this._reinit());
  }

  disconnectedCallback() {
    if (this._trigger) this._trigger.removeEventListener('click', this._boundToggle);
  }

  _init() {
    this._trigger = this.querySelector('.accordion__trigger');
    this._panel = this.querySelector('.accordion__panel');
    if (this._trigger) this._trigger.addEventListener('click', this._boundToggle);
  }

  _reinit() {
    if (this._trigger) this._trigger.removeEventListener('click', this._boundToggle);
    this._init();
  }

  _toggle() {
    if (!this._trigger || !this._panel) return;
    const isOpen = this._trigger.getAttribute('aria-expanded') === 'true';
    this._trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    this._panel.classList.toggle('accordion__panel--open', !isOpen);
  }
}

if (!customElements.get('accordion-section')) {
  customElements.define('accordion-section', AccordionSection);
}
